import React from 'react';

const AboutTheJob = () => {
  return (
    <>
      <div className="space-y-4">
        <div className="fredoka text-[32px] font-medium leading-normal tracking-[-0.64px] text-[#012E33]">
          About the job
        </div>
        <div className="fredoka mt-4 text-[16px] font-normal leading-[26px] tracking-[-0.32px] text-[#678285] md:text-[18px] md:tracking-[-0.36px]">
          The ideal candidate will be responsible for developing, implementing, and executing
          strategic marketing plans to drive brand awareness, market share, and sales growth within
          the pharmaceutical industry. This role requires a deep understanding of the Biopharma/
          Life science market, including regulatory requirements, market dynamics, and customer
          needs.
        </div>
      </div>
    </>
  );
};

export default AboutTheJob;
